// Thin, safe wrapper around GA4 + Clarity. Never throws if scripts haven't loaded yet.
// Funnel events fire only on production-style hosts; local/preview still tracked so we
// can validate during testing.

export const track = (event, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch (err) {
    console.warn("GA4 track failed:", event, err);
  }
  try {
    if (typeof window !== "undefined" && typeof window.clarity === "function") {
      // Surface the event name as a Clarity custom tag — easy to filter in dashboards.
      window.clarity("event", event);
      // Tag any string-valued params (Clarity tags are key/value strings).
      Object.entries(params).forEach(([k, v]) => {
        if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") {
          window.clarity("set", k, String(v));
        }
      });
    }
  } catch (err) {
    console.warn("Clarity track failed:", event, err);
  }
};
